export default "__VITE_ASSET__CaEg4pE7__"